<template>
  <el-dialog :visible="visible" class="useredit-card" :before-close="close">
    <div class="title">修改个人信息</div>
    <div class="img">
      <img :src="avatarUrl" />
      <input
        type="file"
        id="uploadfile"
        accept="image/*"
        @change="selectImage"
      />
    </div>
    <div class="mask" v-if="!avatar">
      <div class="camera"></div>
      <span>修改头像</span>
    </div>
    <div class="msg-modify">
      <p>职位</p>
      <input v-model="title" :placeholder="title ? '' : '请输入您的职位'" />
    </div>
    <div class="msg-modify">
      <p>部门</p>
      <input v-model="dep" :placeholder="title ? '' : '请输入您的部门'" />
    </div>
    <div class="btns">
      <button @click="visible = false">取消</button>
      <button @click="save">提交</button>
    </div>
  </el-dialog>
</template>

<script>
import { mapActions } from "vuex";
import AvatarCropper from "@/components/userInfor/avatarcropper";
export default {
  name: "useredit-card",
  data() {
    return {
      visible: false,
      userInfor: null,
      avatar: "",
      nickname: "",
      dep: "",
      title: "",
    };
  },
  computed: {
    avatarUrl() {
      return this.avatar || this.userInfor.avatar || this.userInfor.user.avatar;
    },
  },
  methods: {
    ...mapActions("userInfor", ["setUserDetailInfo"]),
    selectImage(e) {
      const file = e.target.files[0];
      const reader = new FileReader();
      const vm = this;
      reader.onload = (e) => {
        document.querySelector("#uploadfile").value = ""; // 清空input
        AvatarCropper.open(e.target.result, file).then((res) => {
          if (res.action === "confirm") {
            vm.avatar = res.url;
          }
          document.querySelector(".useredit-card .el-dialog").className =
            "el-dialog";
        });
        document.querySelector(".useredit-card .el-dialog").className =
          "el-dialog translate-left";
      };
      reader.readAsDataURL(file);
    },
    close() {
      this.visible = false;
      AvatarCropper.close();
    },
    save() {
      // this.setUserDetailInfo({
      //   user_id: this.userInfor.user_id,
      //   avatar: this.avatar,
      //   dep: this.dep,
      //   title: this.title
      // })
      this.visible = false;
    },
  },
  created() {
    this.nickname = this.userInfor.user.nickname;
    this.dep = this.userInfor.dep;
    this.title = this.userInfor.title;
  },
  components: {},
};
</script>

<style lang="scss">
.useredit-card {
  > .el-dialog {
    width: 394px;
    height: 500px;
    background: rgba(255, 255, 255, 1);
    border-radius: 6px;
    transition: all 0.8s ease;
    > .el-dialog__header {
      width: 0;
      height: 0;
      padding: 0 !important;
      margin: 0;
      .el-dialog__close {
        color: rgba(255, 255, 255, 1);
      }
    }
    .el-dialog__body {
      padding: 28px 0 0 28px;
      position: relative;
      > .title {
        font-size: 20px;
        font-family: MicrosoftYaHei-Bold;
        font-weight: bold;
        color: rgba(48, 48, 48, 1);
        line-height: 26px;
        text-align: left;
      }
      > .img {
        position: relative;
        width: 100px;
        height: 100px;
        border-radius: 50%;
        border: 1px solid rgba(151, 151, 151, 1);
        margin: 27px 0 0 119px;
        background-size: cover;
        > img {
          position: absolute;
          top: 0px;
          left: 0px;
          width: 100px;
          height: 100px;
          border-radius: 50%;
        }
        > input {
          position: absolute;
          top: 0px;
          left: 0px;
          display: inline-block;
          width: 100px;
          height: 100px;
          border-radius: 50px;
          z-index: 10;
          opacity: 0;
          &:hover {
            cursor: pointer;
          }
        }
      }
      > .mask {
        width: 100px;
        height: 100px;
        border-radius: 50%;
        position: absolute;
        left: 147px;
        top: 81px;
        display: flex;
        flex-direction: column;
        background-color: rgba(0, 0, 0, 0.4);
        padding: 30px 0px 0px 0px;

        > .camera {
          width: 28px;
          height: 25px;
          margin-left: 36px;
          background-size: cover;
          background-image: url("~@/assets/img/camera.png");
        }
        > span {
          font-size: 12px;
          font-family: MicrosoftYaHei;
          color: rgba(255, 255, 255, 1);
          line-height: 16px;
        }
      }
      > .msg-modify {
        p {
          font-size: 14px;
          font-family: MicrosoftYaHei;
          color: rgba(51, 51, 51, 1);
          line-height: 19px;
          text-align: left;
          margin: 26px 0 15px 0;
        }
        input {
          width: 338px;
          height: 42px;
          padding-left: 15px;
          margin-left: -25px;
          font-size: 14px;
          font-family: MicrosoftYaHei;
          color: rgba(51, 51, 51, 1);
          line-height: 19px;
          outline: none;
          border: 1px solid rgba(234, 234, 234, 1);
        }
      }
      > .btns {
        width: 260px;
        margin-top: 37px;
        margin-left: 39px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        button:nth-child(1) {
          width: 110px;
          height: 38px;
          border-radius: 28px;
          border: 1px solid rgba(231, 0, 18, 1);
          background: rgba(255, 255, 255, 1);
          font-size: 16px;
          font-family: MicrosoftYaHei-Bold;
          font-weight: bold;
          color: rgba(231, 0, 18, 1);
          line-height: 28px;
          outline: none;
        }
        button:nth-child(2) {
          width: 110px;
          height: 38px;
          border-radius: 28px;
          border: 1px solid rgba(231, 0, 18, 1);
          background: rgba(231, 0, 18, 1);
          font-size: 16px;
          font-family: MicrosoftYaHei-Bold;
          font-weight: bold;
          color: rgba(255, 255, 255, 1);
          line-height: 28px;
          outline: none;
        }
      }
    }
  }
}
.translate-left {
  transform: translate(-200px, 0);
}
</style>
